import { connect } from 'react-redux';
import React from 'react';

import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import ABTest from '../../abtest/components/abtest';

import '../css/product-salecallout.less';

export const SaleCallOut = ({ product = {}, price = {}, callout, className }) => {
    return (
        <ABTest experimentID="pstore-violator" ssrRender={true}>
            {data => {
                let { metadata, sku } = product;
                const pStoreData = data || {};
                const hasPStoreMessage = pStoreData && (pStoreData.skus || []).includes(sku);
                const violatorMsg =
                    hasPStoreMessage && !(metadata && metadata.saleCallout) ? pStoreData.message : callout;
                if (!!violatorMsg) {
                    const violatorMarkup = Helpers.createMarkup(violatorMsg);
                    return (
                        <div
                            className={`promo-text${className ? ' ' + className : ''}`}
                            dangerouslySetInnerHTML={violatorMarkup}
                        ></div>
                    );
                }
                let promoText,
                    regularPrice,
                    salePrice,
                    discount,
                    discountPercent = null;

                if (metadata && metadata.saleCallout && price.regularPrice && price.salePrice) {
                    regularPrice = price.regularPrice.toString().replace(/[^\d.-]/g, '') * 1;
                    salePrice = price.salePrice.toString().replace(/[^\d.-]/g, '') * 1;
                    discount = Math.max(0, (regularPrice - salePrice).toFixed(4) * 1);
                    discountPercent = discount > 0 ? ((discount / regularPrice) * 100).toFixed(4) * 1 : 0;
                    if (metadata.saleCallout === '%') {
                        promoText = discount > 0 ? `Save ${Math.floor(discountPercent)}%` : '';
                    } else if (metadata.saleCallout === '$') {
                        promoText = discount > 0 ? `Save $${Math.floor(discount)}` : '';
                    } else {
                        promoText = metadata.saleCallout.replace(/({\$})|({%})/g, match => {
                            if (match === '{%}') {
                                return discount > 0 ? `${Math.floor(discountPercent)}%` : '';
                            } else if (match === '{$}') {
                                return discount > 0 ? `$${Math.floor(discount)}` : '';
                            }
                        });
                    }
                    return promoText ? (
                        <div className={`promo-text${className ? ' ' + className : ''}`}>{promoText}</div>
                    ) : null;
                }
                return null;
            }}
        </ABTest>
    );
};

const mapStateToProps = (state, ownProps) => {
    let price =
        ownProps.product && Helpers.getProductPrice(ownProps.product, state.productData.productInfo.productPrices);
    return {
        price,
    };
};

export default connect(mapStateToProps, null)(withError(SaleCallOut));
